import React from 'react';
import {
  Grid, Typography, Box, Avatar, Tooltip, colors, makeStyles
} from '@material-ui/core';

import Card from 'src/components/Card';
import { WorkflowWithStepsAndEdges } from 'src/types';
import { AvatarGroup } from '@material-ui/lab';
import { useHistory } from 'react-router';

interface Props {
  workflow: WorkflowWithStepsAndEdges
}

const useStyles = makeStyles((theme) => ({
  avatar: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.common.white,
  },
  card: {
    height: 200,
  }
}));

const getColor = (name: string) => {
  const colorsList = [
    colors.red['700'],
    colors.purple['700'],
    colors.deepPurple['700'],
    colors.indigo['700'],
    colors.blue['700'],
    colors.teal['700'],
    colors.green['700'],
    colors.orange['700'],
    colors.deepOrange['700'],
  ];
  const nameValue = name.split('').reduce((acc, el) => el.charCodeAt(0), 0) % colorsList.length;

  return colorsList[nameValue];
};

const WorkflowCard = ({ workflow }: Props) => {
  const history = useHistory();
  const classes = useStyles();
  const MAX = 3;
  const roles = (
    <AvatarGroup
      max={MAX + 1 === workflow.roles.length ? MAX + 1 : MAX}
    >
      {
        workflow.roles.map((role) => (
          <Tooltip title={role.name} placement="top">
            <Avatar
              className={classes.avatar}
              style={{ backgroundColor: getColor(role.name) }}
            >
              {role.name.split(' ').map((el) => el[0].toUpperCase()).join('')}
            </Avatar>
          </Tooltip>
        ))
      }
    </AvatarGroup>
  );

  return (
    <Card
      title={workflow.name}
      p={2}
      action={roles}
      onClick={() => history.push(`/workflows/${workflow.id}`)}
      className={classes.card}
    >
      <Box display="flex" flexDirection="column">
        <Typography variant="subtitle1">
          {workflow.description}
        </Typography>
        {/* <Box mt={1}> */}
        {/*  <Typography variant="caption"> */}
        {/*    27 engagements | 148 tasks */}
        {/*  </Typography> */}
        {/* </Box> */}
      </Box>
    </Card>
  );
};

export default WorkflowCard;
